import React, { useState } from "react";
import "./auth.css";
import ThemeToggle from "../ThemeToggle";
import { API_ENDPOINTS } from "../../config";
import axios from "axios";

function ResetPassword() {
  const [step, setStep] = useState(1); // 1 = request code, 2 = reset password
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({ show: false, success: false, message: "" });

  // Step 1: Send Reset Code
  const handleRequestCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPopup({ show: false, success: false, message: "" });

    try {
      const response = await axios.post(API_ENDPOINTS.SEND_EMAIL_RESET_PASSWORD, { email });

      if (response.data.status === "success") {
        setPopup({ show: true, success: true, message: "Code sent successfully!" });
        setStep(2); // ✅ Move to step 2
      } else {
        setPopup({
          show: true,
          success: false,
          message: response.data.message || "Failed to send code. Try again.",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setPopup({ show: true, success: false, message: "Something went wrong!" });
    } finally {
      setLoading(false);
    }
  };

  // Step 2: Verify Code + Reset Password
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPopup({ show: false, success: false, message: "" });

    try {
      const response = await axios.post(API_ENDPOINTS.RESET_PASSWORD, {
        email,
        code,
        newPassword,
      });

      if (response.data.status === "success") {
        setPopup({ show: true, success: true, message: "Password reset successful!" });
        setEmail("");
        setCode("");
        setNewPassword("");
       // setStep(1); // ✅ back to step 1 after success
        window.location.href = "/login";
      } else {
        setPopup({
          show: true,
          success: false,
          message: response.data.message || "Invalid code or password reset failed.",
        });
      }
    } catch (error) {
      console.error("Error:", error);
      setPopup({ show: true, success: false, message: "Something went wrong!" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      {/* 🔘 Dark Mode Toggle Button */}
      <div className="auth-theme-toggle">
        <ThemeToggle />
      </div>

      <div className="auth-box">
        <h2>Reset Password</h2>

        {/* Step 1: Request Code */}
        {step === 1 && (
          <form onSubmit={handleRequestCode}>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? <span className="spinner"></span> : "Send Reset Code"}
            </button>
          </form>
        )}

        {/* Step 2: Enter Code + New Password */}
        {step === 2 && (
          <form onSubmit={handleResetPassword}>
            <input
              type="text"
              name="code"
              placeholder="Enter 6-digit code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
            />
            <input
              type="password"
              name="newPassword"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? <span className="spinner"></span> : "Reset Password"}
            </button>
            <button
              type="button"
              className="secondary-btn"
              onClick={() => setStep(1)} // allow going back
            >
              Back
            </button>
          </form>
        )}

        {/* ✅ Popup Overlay */}
        {popup.show && (
          <div className="popup-overlay">
            <div className={`popup-content ${popup.success ? "success" : "error"}`}>
              <p>{popup.message}</p>
              <button onClick={() => setPopup({ show: false, success: false, message: "" })}>
                Close
              </button>
            </div>
          </div>
        )}

        <div className="auth-links">
          <a href="/login">Back to Login</a>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
